import React from 'react'
import intl from 'react-intl-universal'
import styled from 'styled-components'
import { Navigation } from '@raysync/common/services'
import { Button, LargeWrapper, ShowAtMobile, HideAtMobile } from '@raysync/common/components'
import ArrowRight from '@raysync/common/components/svg/smb/arrow-3'
import { Devices } from '@raysync/common/theme'

const BannerContainer = styled.div`
  position: relative;
  height: 460px;
  display: flex;
  @media ${Devices.phone} {
    padding-top: 0.7rem;
    height: 9rem;
  }
`

const BannerWrapper = styled(LargeWrapper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;

  @media ${Devices.phone} {
    flex-direction: column;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
  @media ${Devices.phone} {
    width: 100%;
  }
`

const Title = styled.h1`
  font-size: 36px;
  line-height: 1.25;
  color: #fff;
  font-weight: bold;
  @media ${Devices.phone} {
    font-size: 0.48rem;
  }
`

const Desc = styled.p`
  line-height: 24px;
  line-height: 1.5;
  margin: 24px 0;
  color: #fff;
  @media ${Devices.phone} {
    font-size: 0.3rem;
    margin: 0.26rem 0 0.42rem;
  }
`

const BannerSvg = styled.div`
  width: 50%;
  padding: 30px 0;
  display: flex;
  justify-content: center;
  svg {
    max-height: 400px;
  }
  @media ${Devices.phone} {
    padding: 0.3rem 0;
    width: 100%;
    svg {
      max-height: 4.2rem;
    }
  }
`
const BannerButton = styled(Button)`
  max-width: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px !important;
  svg {
    width: 20px;
    height: 18px;
    margin-left: 8px;
  }
  @media ${Devices.phone} {
    width: 4.8rem;
    border-radius: 0.35rem !important;
    padding: 0 0.4rem !important;
    font-size: 0.3rem !important;
    svg {
      width: 0.3rem;
      height: 0.28rem;
    }
  }
`

const Banner = ({ title, desc, svg, btnId, banner, mBanner }) => {
  return (
    <BannerContainer>
      <BannerWrapper>
        <ContentWrapper>
          <Title>{title}</Title>
          <Desc>{desc}</Desc>
          <BannerButton
            size='large'
            id={btnId}
            onClick={() => {
              Navigation.toApply({ type: 'solution' })
            }}
          >
            {intl.get('solution.dashboard.banner.button')}
            <ArrowRight />
          </BannerButton>
        </ContentWrapper>
        <BannerSvg>{svg}</BannerSvg>
      </BannerWrapper>
      <ShowAtMobile>{mBanner}</ShowAtMobile>
      <HideAtMobile>{banner}</HideAtMobile>
      {/* <Billboard fluid={banner.childImageSharp.fluid} /> */}
    </BannerContainer>
  )
}
export default Banner
